<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>Admin</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>Admin</h2>
      </div>
    </div>

    <div class="contents">
      <div class="conWrap">
        <div class="sortWrap">
          <dl class="w488 mgr20">
            <dt>등록일자</dt>
            <dd style="display: flex">
              <div class="form_input_area" style="width: 47%">
                <datepicker
                  v-model="state.rct_dt_fr"
                  :locale="ko"
                  class="form_input"
                  typeable
                  ref="startDate"
                  @input="inputDate"
                  maxlength="10" />
                <button
                  type="button"
                  class="btn_calendar"
                  @click="openCalendar('startDate')"
                  @blur="closeCalendar('startDate')">
                  <span>날짜선택</span>
                </button>
              </div>
              <span style="margin: 13px 0px 0px 10px">~</span>
              <div class="form_input_area" style="width: 46%">
                <datepicker
                  v-model="state.rct_dt_to"
                  :locale="ko"
                  class="form_input"
                  typeable
                  ref="endDate"
                  @input="inputDate"
                  maxlength="10" />
                <button
                  type="button"
                  class="btn_calendar"
                  @click="openCalendar('endDate')"
                  @blur="closeCalendar('endDate')">
                  <span>날짜선택</span>
                </button>
              </div>
            </dd>
          </dl>
          <dl class="w265 mgr20">
            <dt class="w72">신청ID</dt>
            <dd>
              <div class="inpTxt">
                <input
                  type="text"
                  v-model="state.login_id"
                  id="pol"
                  title="id" />
              </div>
            </dd>
          </dl>
          <dl>
            <dt>승인여부</dt>
            <dd>
              <div class="inpSlt">
                <button type="button" class="sltBtn" title="입력자 선택">
                  <span>전체</span>
                </button>
                <ul>
                  <li>
                    <button type="button" class="sltOpt" title="선택">
                      <span>전체</span>
                    </button>
                  </li>
                  <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                  <li>
                    <button type="button" class="sltOpt">
                      <span>승인</span>
                    </button>
                  </li>
                  <li>
                    <button type="button" class="sltOpt">
                      <span>미승인</span>
                    </button>
                  </li>
                </ul>
              </div>
            </dd>
          </dl>
          <button @click="admMgr()" type="button" class="btnSearch">
            <span class="hide">검색</span>
          </button>
        </div>

        <h3 class="conTit">조회결과</h3>

        <div class="tabStyle2">
          <table>
            <caption>
              조회결과
            </caption>
            <colgroup>
              <col width="60" />
              <col width="150" />
              <col width="150" />
              <col width="80" />
              <col width="150" />
              <col width="150" />
              <col width="130" />
              <col width="80" />
              <col width="80" />
              <col width="200" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col" height="62">순번</th>
                <th scope="col">신청ID</th>
                <th scope="col">사업자식별번호</th>
                <th scope="col">상태</th>
                <th scope="col">고객한글명</th>
                <th scope="col">고객영문명</th>
                <th scope="col">등록일자</th>
                <th scope="col">정보</th>
                <th scope="col">계정잠금</th>
                <th scope="col">대면청약여부</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in state.data" :key="index + 1">
                <td height="74">{{ parseInt(index) + 1 }}</td>
                <td>{{ item.login_id }}</td>
                <td>{{ item.biz_Idf_No }}</td>
                <td v-if="item.pwd_lock_yn == 'Y'">
                  <a @click="lockUpd(item.login_id)" class="fcRed">LOCK</a>
                </td>
                <td v-if="item.pwd_lock_yn == 'N' && item.appr_typ_cd == 'N'">
                  <a @click="confirmUsr(item.login_id)" class="fcBlue"
                    >미승인</a
                  >
                </td>
                <td v-if="item.pwd_lock_yn == 'N' && item.appr_typ_cd == 'Y'">
                  <a class="fcRed">승인</a>
                </td>
                <td>{{ item.n_ctorkr }}</td>
                <td>{{ item.n_ctoren }}</td>
                <td>{{ item.reg_ymd }}</td>
                <td>
                  <a @click="mbrInfoUptForm(item.login_id, state.data)">수정</a>
                </td>
                <td><a @click="lockUser(item.login_id)">잠금</a></td>
                <td class="se">
                  <div class="radio">
                    <input
                      type="radio"
                      value="Y"
                      :name="'agrY_' + index"
                      :id="'agrY_' + index"
                      :checked="item.ctr_crt_yn == 'Y'"
                      @change="handleCtrCrtYn(item, 'Y')" />
                    <label :for="'agrY_' + index">예</label>
                    <input
                      style="margin-left: 1rem"
                      type="radio"
                      value="N"
                      :name="'agrN_' + index"
                      :id="'agrN_' + index"
                      :checked="item.ctr_crt_yn == 'N' || item.ctr_crt_yn == ''"
                      @change="handleCtrCrtYn(item, 'N')" />
                    <label :for="'agrN_' + index">아니오</label>
                  </div>
                </td>
              </tr>

              <tr v-if="state.data.length == 0">
                <td colspan="10">
                  <p class="noData">조회된 결과가 없습니다.</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import { globalState } from "@/common/globalState";
import Datepicker from "vue3-datepicker";
import { ko } from "date-fns/locale";

const swalAlert = inject("swalAlert");
const router = useRouter();
const axios = inject("axios");

let startDate = ref(null);
let endDate = ref(null);

const openCalendar = (tp) => {
  switch (tp) {
    case "startDate":
      startDate.value.renderView("day");
      break;
    case "endDate":
      endDate.value.renderView("day");
      break;
  }
};

const closeCalendar = (tp) => {
  switch (tp) {
    case "startDate":
      startDate.value.renderView("none");
      break;
    case "endDate":
      endDate.value.renderView("none");
      break;
  }
};

const state = reactive({
  currDateFormat: util.formatDate(new Date(), "yyyy-mm-dd"),
  mode: process.env.NODE_ENV,
  athTypeCd: 1,
  currDate: util.formatDate(new Date(), "yyyymmdd"),
  rct_dt_fr: new Date(
    util.addMonths(util.formatDate(new Date(), "yyyymmdd"), -1)
  ),
  rct_dt_to: new Date(util.formatDate(new Date(), "yyyy-mm-dd")),
  apv_yn: "",
  login_id: "",
  data: {},

  //
  bcOutputVo: [],
  res: {},
});
const store = useStore();

onMounted(async () => {
  await admMgr();
  axios.json("/logHisLdg.do", { memo: "Admin", page: window.location.hash });
});

const handleCtrCrtYn = async (item, val) => {
  try {
    console.log("handleCtrCrtYn==>" + val);
    console.log(JSON.stringify(item));
    axios
      .json("/sbcpYnChng.do", {
        ctr_crt_yn: _.isEmpty(val) ? "N" : val,
        corp_no: item.corp_no,
        login_id: "",
      })
      .then(function (result) {
        const msg =
          val == "Y"
            ? "대면 청약 허용으로 변경되었습니다."
            : "대면 청약 불가로 변경되었습니다.";
        return swalAlert(msg).then((res) => {
          axios.json("/logHisLdg.do", {
            memo: "대면여부변경" + val,
            page: window.location.hash,
          });
          admMgr();
        });
      });
  } catch (e) {
    console.err("에러 발생 확인 필요");
  }
};

const admMgr = async () => {
  let param = {};
  param.login_id = state.login_id;
  param.rct_dt_fr = util.formatDate(state.rct_dt_fr, "yyyy-mm-dd");
  param.rct_dt_to = util.formatDate(state.rct_dt_to, "yyyy-mm-dd");
  if ($(".sltBtn").text() == "미승인") {
    param.apv_yn = "N";
  } else if ($(".sltBtn").text() == "승인") {
    param.apv_yn = "Y";
  } else {
    param.apv_yn = "";
  }
  await axios.json("/admMgr.do", param).then(function (result) {
    state.data = rmSpaceObject(result.data.data);
  });
};

function rmSpaceObject(obj) {
  return _.mapValues(obj, (value) =>
    _.isString(value) ? _.trim(value) : value
  );
}

const lockUpd = (o) => {
  let param = {};
  param.login_id = _.trim(o);
  axios.json("/unlockUsr.do", param).then(function (result) {
    return swalAlert(result.data.msg).then((result) => {
      axios.json("/logHisLdg.do", {
        memo: "관리자 LOCK 해제",
        page: window.location.hash,
      });
      admMgr();
    });
  });
};

const lockUser = (o) => {
  let param = {};
  param.login_id = _.trim(o);
  axios.json("/userLock.do", param).then(function (result) {
    return swalAlert(result.data.msg).then((result) => {
      axios.json("/logHisLdg.do", {
        memo: "관리자 LOCK 설정",
        page: window.location.hash,
      });
      admMgr();
    });
  });
};

const sbcpYnChng = (o) => {
  let param = {};
  param.login_id = _.trim(o);
  axios.json("/sbcpYnChng.do", param).then(function (result) {
    return swalAlert(result.data.msg).then((result) => {
      axios.json("/logHisLdg.do", {
        memo: "관리자 LOCK 설정",
        page: window.location.hash,
      });
      admMgr();
    });
  });
};

const confirmUsr = (o) => {
  store.commit("common/commitCusId", _.trim(o));
  router.push({ name: "confirUsrDeta" });
};

const mbrInfoUptForm = async (o, data) => {
  let param = {};
  _.each(data, function (value, idx) {
    if (o == value.login_id) {
      param.login_id = value.login_id;
      param.biz_no = value.biz_no;
      param.corp_no = value.corp_no;
    }
  });
  console.log(param);
  store.commit("common/loginIdChk", param.login_id);
  store.commit("common/bizNoChk", param.biz_no);
  store.commit("common/commitCorpNo", param.corp_no);
  router.push({ name: "mbrInfoUpt" });
};
</script>

<style></style>
